import React from "react";
import {ZendeskForm} from "@crescolabs/brand-common";
import {productTypeOptions} from "../zendesk/helpers";
import {themeObj} from "../theme";

export default function NewContactPage({loading, isStaging}) {
  return (
    <ZendeskForm
      brandTheme={themeObj}
      loading={loading}
      isStaging={isStaging}
      ticketID={360005270154}
      apiBrand="Wonder"
      formBrand="Wonder"
      formTag="wwwebform"
      productTypeOptions={productTypeOptions}
    />
  );
}
